import React, {Component} from 'react';
import { Form, Row, Col, Image, Card} from 'react-bootstrap';
import productlist from '../../product.json';
import  './ProductDetails.css';


class ProductDetails extends Component {

       onSelectProduct(event) {
            this.props.productToDeliver(event.target.value);
       }

       componentDidMount(){
            if(this.props.selectedProduct != null) {
                document.querySelector('input[name = "product"]:not([disabled])').checked = true;
                this.props.productToDeliver(document.querySelector('input[name = "product"]:checked').value);
            }

       }

       componentDidUpdate() {
            if(document.querySelector('input[name = "product"]:checked') != null && document.querySelector('input[name = "product"]:checked').disabled){
                document.querySelector('input[name = "product"]:not([disabled])').checked = true;
                this.props.productToDeliver(document.querySelector('input[name = "product"]:checked').value);
           }
        }

       render() {
        const productList = productlist;
        productList.forEach((item,i) => { 
            if(this.props.selectedProduct === parseInt(item.value).toString() || parseInt(item.value) === 360) {
                productList[i].disabled = true;
                productList[i].visibility = '_6opacity';
            } else {
                productList[i].disabled = false;
                productList[i].visibility = '';
            }
        });

        var products = productList.map(item =>(
            <Col className="margin-bottom d-flex justify-content-center align-items-center"  key = {item.id}>
                <Card id = {'prod'+item.value} className="border-0">
                    <Card.Body align="center">
                        <Card.Title> <Form.Check
                                type="radio"
                                label= {item.label}
                                name= {item.name}
                                disabled= {item.disabled}
                                value={item.value}
                                checked={this.props.stateSwapped === item.value}
                                onChange={(event) => this.onSelectProduct(event)}
                                onClick={(event) => this.onSelectProduct(event)}
                                id={item.id}/> </Card.Title>
                        <Image src ={item.imagesrc} width = "150px" className={item.visibility}></Image>

                         { /* "text-muted" */}
                        
                        <Card.Subtitle className={item.disabled ? "mb-2 text-muted" : "mb-2"}>Dimensions</Card.Subtitle>
                        
                        <Card.Text className={item.disabled ? "text-muted" : ""} >
                        Height: {item.height} <br/> Width: {item.width}<br/> Depth: {item.depth}
                        </Card.Text>

                    </Card.Body>
                </Card>
            </Col>
        ));

        return (
                <Row>
                        {products}
                </Row>
                 )
    }
}
   



export default  ProductDetails;